import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getConfig } from '../../configuracao/configLocal';
import { getControladorAnelList } from './selectdbAtions';

import './contentHeaderFilter.css';

class SelectConfAnel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filterGrupo: this.getGrupoFiltro(),
      filterNumCont: this.getNumContFiltro(),
    };
  }

  componentDidMount() {
    this.props.getControladorAnelList();
  }

  componentDidUpdate() {
    const grupo = this.getGrupoFiltro();
    const numCont = this.getNumContFiltro();

    if (grupo !== this.state.filterGrupo || numCont !== this.state.filterNumCont) {
      this.setState({
        filterGrupo: grupo,
        filterNumCont: numCont,
      });
    }
  }

  getGrupoFiltro() {
    return this.props['data-grupo'] || getConfig('grupo');
  }

  getNumContFiltro() {
    return this.props['data-num-controlador'] || getConfig('numCont');
  }

  renderOptions() {
    const list = this.props.list || [];
    const grupoFisico = this.getGrupoFiltro();
    const numControlador = this.getNumContFiltro();

    if (!grupoFisico || !numControlador) {
      return <option value="">Selecione grupo e controlador</option>;
    }

    if (list.length === 0) {
      return <option value="">Carregando...</option>;
    }

    const newList = list.filter(
      anel =>
        String(anel.grupo_fisico_id) === String(grupoFisico) &&
        String(anel.numero_controlador) === String(numControlador) &&
        anel.ativo === 1,
    );

    if (newList.length === 0) {
      return <option value="">Nenhum anel encontrado</option>;
    }

    return newList.map(anel => (
      <option key={anel.id} id={anel.id} value={anel.anel}>
        {anel.anel}
      </option>
    ));
  }

  handleChange(event) {
    this.props.onChange(event);
  }

  render() {
    return (
      <div>
        <label htmlFor={'selectAnel'} style={{ fontSize: '13px', fontWeight: '600' }}>
          Anel
        </label>
        <select
          id={'selectAnel'}
          name={'selectAnel'}
          style={{
            display: 'block',
            marginBottom: '5px',
          }}
          className="form-control"
          onChange={event => {
            this.handleChange(event);
          }}
          value={this.props.value}
        >
          {this.renderOptions()}
        </select>
      </div>
    );
  }
}

const mapStateToProps = state => ({ list: state.controladorCad.listAnel });
const mapDispatchToProps = dispatch => bindActionCreators({ getControladorAnelList }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectConfAnel);
